
export default {
    render: function(def, ctx, callback){
        // If page break is the last control in the detail section, we don't want to render the header (because it will have the wrong context) ... EK
        if (def.runTime.forceBreak === false || ctx.layout.Sections.Detail.Controls.length - 1 === ctx.layout.Sections.Detail.Controls.indexOf(def)) {
            // We don't want to pre-render the header, we need to flag the context to control this after the context has changed...EK
            ctx.newPageNeeded = ctx.activePageBreak = true;
            callback();
        }
        else {
            // We need to stop rendering the detail and render the page footer so this detail can continue to render.
            ctx.renderPageFooter(() => {
                ctx.makeNewPage(false, () => {
                    ctx.renderAllPageHeaders().then(() => {
                        //We now need the root context ptr to be offset to continue this detail section...EK
                        ctx.rootContext.ptr.top -= def.runTime.top;
                        ctx.activePageBreak = true;
                        callback();
                    });
                });
            });
        }
    },
    preRender: function(def, ctx, callback){
        if (def.runTime == null){
            def.runTime = {top: def.Top};
        }
        else {
            def.runTime.top = def.Top;      // Reset the top in case of growth layout changes...EK
        }
        callback();
    }
};
